import { useEffect, useRef, useState } from 'react';

export const useDebounce = (value, delay = 300) => {
  const [debounceValue, setDebounceValue] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounceValue(value);
    }, delay);
    return () => {
      clearTimeout(handle);
    };
  });
  return debounceValue;
};

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useCompare = (value) => {
  const prevVal = usePrevious(value);
  return prevVal !== value;
};

export const useDelayRemoveDom = (value, delay) => {
  const [open, setOpen] = useState(value);
  const [openDom, setDom] = useState(value);
  const [openInnerDom, setInnerDom] = useState(value);
  useEffect(() => {
    if (open) {
      setDom(open);
      const removeDOm = setTimeout(() => {
        setInnerDom(open);
      }, 100);
      return () => {
        clearTimeout(removeDOm);
      };
    }
    setInnerDom(open);
    const removeDOm = setTimeout(() => {
      setDom(open);
    }, delay);
    return () => {
      clearTimeout(removeDOm);
    };
  }, [open, delay]);
  return [openInnerDom, openDom, setOpen];
};

export default useDebounce;
